export class EvaluateRestoreTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ec2Params",
            "baseName": "ec2Params",
            "type": "Ec2TemplateParams",
            "format": ""
        },
        {
            "name": "s3Params",
            "baseName": "s3Params",
            "type": "S3TemplateParams",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EvaluateRestoreTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
